import PerformanceListComponent from './PerformanceList.component'

export default PerformanceListComponent